// Short Q&A used on both the public /intrebari page and inline on the
// authenticated /cont page. Kept in one place so we don't drift.
export type FaqItem = { q: string; a: string };

export const FAQ: FaqItem[] = [
  {
    q: "Aplicația e cu adevărat gratuită?",
    a: "Da. Aplicația e și va rămâne gratuită, fără reclame, fără abonamente și fără limite de timp.",
  },
  {
    q: "Cum funcționează compararea ofertelor RCA?",
    a: 'Nu suntem integrați direct cu asigurătorii — lucrăm cu <strong>Inter Broker</strong>, prin care obținem ofertele de la asigurătorii din România. Tu introduci datele mașinii și CNP-ul o singură dată, iar Inter Broker ne returnează tabloul comparativ în mai puțin de 12 secunde. Nu plătești nimic în plus față de prețul direct al asigurătorului.',
  },
  {
    q: "Datele mele sunt în siguranță?",
    a: "Datele se stochează criptate AES-256 pe servere din UE. Nu vindem și nu împărtășim date cu terți pentru reclame. Suntem aliniați GDPR.",
  },
  {
    q: "Pot să adaug mașini ale altor membri din familie?",
    a: "Da. Pe planul Concierge poți adăuga oricâte mașini, fiecare cu „proprietar” diferit. Pe planul Flotă există conturi separate cu roluri (admin, manager, șofer) și fiecare șofer își vede doar mașinile alocate.",
  },
  {
    q: "Funcționează și pentru iPhone?",
    a: "Pe iPhone nu există aplicație nativă și nu se lucrează la una momentan. Pentru utilizatorii iOS, aplicația web funcționează în orice browser modern — inclusiv Safari pe iPhone — și acoperă aceleași funcții esențiale: documente, reminder-uri, comparare RCA.",
  },
];
